module.exports = __webpack_public_path__ + "static/media/Clarissa_RDA.90f039e7.png";